/**
 * Check if Vision is running in local mode
 * @returns true if NEXT_PUBLIC_VISION_MODE is 'local', false otherwise
 */
export function isVisionLocal(): boolean {
  return process.env.NEXT_PUBLIC_VISION_MODE === 'local'
}
